import { ActionTree, GetterTree, Module, MutationTree } from "vuex";

import actions from "./property-actions.store";
import getters from "./property-getters.store";
import mutations from "./property-mutations.store";

/**
 * property document module
 */
import documentActions from "./property-document/property-document-actions.store";
import documentGetters from "./property-document/property-document-getters.store";
import documentMutations from "./property-document/property-document-mutations.store";

import pictureActions from "./property-picture/property-picture-actions.store";
import pictureGetters from "./property-picture/property-picture-getters.store";
import pictureMutations from "./property-picture/property-picture-mutations.store";

import descriptionActions from "./property-description/property-description-actions.store";
import descriptionGetters from "./property-description/property-description-getters.store";
import descriptionMutations from "./property-description/property-description-mutations.store";

import roomActions from "./property-room/property-room-actions.store";
import roomGetters from "./property-room/property-room-getters.store";
import roomMutations from "./property-room/property-room-mutations.store";

import relationActions from "./property-relation/property-relation-actions.store";
import relationGetters from "./property-relation/property-relation-getters.store";
import relationMutations from "./property-relation/property-relation-mutations.store";

import environmentAction from "./property-environment/property-environment-actions.store";
import environmentGetter from "./property-environment/property-environment-getters.store";
import environmentMutations from "./property-environment/property-environment-mutations.store";

import propertyFinanceMutations from "./property-finance/property-finance-mutations.store";
import propertyFinanceActions from "./property-finance/property-finance-actions.store";
import propertyFinanceGetters from "./property-finance/property-finance-getters.store";

import constructionActions from "./property-construction/property-construction-actions.store";
import constructionGetters from "./property-construction/property-construction-getters.store";
import constructionMutations from "./property-construction/property-construction-mutations.store";

import mijnVerhuisActions from "./property-mijn-verhuis/property-mijn-verhuis-actions.store";
import mijnVerhuisGetters from "./property-mijn-verhuis/property-mijn-verhuis-getters.store";
import mijnVerhuisMutation from "./property-mijn-verhuis/property-mijn-verhuis-mutations.store";

import smoovedActions from "./property-smooved/property-smooved-actions.store";
import smoovedGetters from "./property-smooved/property-smooved-getters.store";
import smoovedMutation from "./property-smooved/property-smooved-mutations.store";

import keuringPlatformActions from "./property-keuring-platform/property-keuring-platform-action.store";
import keuringPlatformGetters from "./property-keuring-platform/property-keuring-platform-gettter.store";
import keuringPlatformMutation from "./property-keuring-platform/property-keuring-platform-mutations.store";

import korfineMutations from "./property-korfine/property-korfine-mutations.store";
import korfineGetters from "./property-korfine/property-korfine-getters.store";
import korfineActions from "./property-korfine/property-korfine-actions.store";

import { IPropertyEditState, PropertyEditState } from "./property-states.store";
import {ProjectServices , PropertyServices} from "../../../services";

export class PropertyEditModule<RootState>
	implements Module<IPropertyEditState, RootState> {
	namespaced: boolean;
	state: IPropertyEditState;
	getters: GetterTree<IPropertyEditState, RootState>;
	actions: ActionTree<IPropertyEditState, RootState>;
	mutations: MutationTree<IPropertyEditState>;
	/**
	 *
	 */
	constructor() {
		this.namespaced = true;
		this.state = new PropertyEditState({
			service: new PropertyServices(),
			searchParam: {},
			projectService: new ProjectServices(),
		});

		this.mutations = {
			...mutations,
			...documentMutations,
			...pictureMutations,
			...descriptionMutations,
			...roomMutations,
			...relationMutations,
			...environmentMutations,
			...propertyFinanceMutations,
			...constructionMutations,
			...mijnVerhuisMutation,
			...smoovedMutation,
      		...keuringPlatformMutation,
			...korfineMutations
		};

		this.actions = {
			...actions,
			...documentActions,
			...pictureActions,
			...descriptionActions,
			...roomActions,
			...relationActions,
			...environmentAction,
			...propertyFinanceActions,
			...constructionActions,
			...mijnVerhuisActions,
			...smoovedActions,
      		...keuringPlatformActions,
			...korfineActions
		};

		this.getters = {
			...getters,
			...documentGetters,
			...pictureGetters,
			...descriptionGetters,
			...roomGetters,
			...relationGetters,
			...environmentGetter,
			...propertyFinanceGetters,
			...constructionGetters,
			...mijnVerhuisGetters,
			...smoovedGetters,
      		...keuringPlatformGetters,
			...korfineGetters
		};
	}
}
